// extracted by mini-css-extract-plugin
export var skipAnimation = "_3r-0";